var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"icon-selector",class:{'selector-active': _vm.checked},on:{"click":_vm.selectItem}},[_c('img',{attrs:{"src":require("../../../assets/img/cart/tick.svg"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }